<template>
	<div style="position: relative;">
		<b-overlay :show="loading || loadingDetails" no-wrap>
			<template #overlay>
				<div class="text-center">

					<p id="cancel-label">{{ loading ? 'Cargando aeropuertos...' : 'Generando detalles...' }}</p>
					<section v-if="loadingDetails">
						<b-progress :value="loadingPercent" variant="success" :striped="true" animated></b-progress>
					</section>
					<br>

					<b-button
						v-if="loadingDetails"
						ref="cancel"
						variant="outline-danger"
						size="sm"
						aria-describedby="cancel-label"
						@click="forceStop = true"
						:disabled="forceStop"
					>
						Cancelar
					</b-button>
					<br>
					<small class="text-danger" v-if="forceStop">Esperando la siguiente iteración para detener el reporte</small>
				</div>
			</template>
		</b-overlay>
		<b-card>
			<b-row>
				<b-form-group class="col-md-6" label="Punto de venta *" >
					<multiselect
						v-model="filters.pointOfSalesSelected"
						:options="$root.auxVars.pointOfSalesOpts"
						label="text"
						placeholder="Seleccione"
						:multiple="false"
						taggable
						track-by="value"
					>
						<template slot="option" slot-scope="props">
							<span>{{ props.option.text}}</span><br>
							<small>{{props.option.domain}}</small>
						</template>
					</multiselect>
				</b-form-group>
			</b-row>
			<b-row>
				<b-col cols="3">
					Fecha Creacion Desde
					<b-form-datepicker
						reset-button
						today-button
						size="sm"
						v-model="filters.startDate"
						:max="maxDate"
					/>
				</b-col>
				<b-col cols="3">
					Hasta
					<b-form-datepicker
						reset-button
						today-button
						size="sm"
						v-model="filters.endDate"
						:max="maxDate"
					/>
				</b-col>
				<b-col cols="3" v-if="false">
					Fecha servicio Desde
					<b-form-datepicker
						reset-button
						today-button
						size="sm"
						v-model="filters.serviceStartDate"
					/>
				</b-col>
				<b-col cols="3" v-if="false">
					Hasta
					<b-form-datepicker
						reset-button
						today-button
						size="sm"
						v-model="filters.serviceEndDate"
					/>
				</b-col>
				<b-col cols="3">
					<b-form-group
						label="Conf. cotizaciones:"
						size="sm"
						>
						<b-form-select v-model="filters.confQuote" class="mb-3" size="sm">
							<b-form-select-option :value="null">Todos</b-form-select-option>
							<b-form-select-option value="withoutPrices">Solo SIN resultados</b-form-select-option>
							<b-form-select-option value="withPrices">Solo CON resultados</b-form-select-option>
						</b-form-select>
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group
						label="."
						size="sm"
						>
						<b-button variant="outline-primary" type="button" @click="searchAction()">
							<md-icon icon="search" v-if="!loading"/>
						</b-button>
					</b-form-group>
				</b-col>

			</b-row>

			<section v-if="!loading && !$root.isEmpty(loaded.airports)">
				<BarGraph ref="aptos-chart"> </BarGraph>

					<b-form-group
						class="col-md-4 col-12"
						label="Selecciona un aeropuerto"
					>
					<b-form-select :options="listAirports" v-model="airportSelected"></b-form-select>
				</b-form-group>
				<section v-if="airportSelected !== null" class="mt-5">
					<BarGraph ref="cutoff-chart"> </BarGraph>
					<BarGraph ref="service-dates-chart" class="mt-3"> </BarGraph>
					<BarGraph ref="hotels-chart" class="mt-3"> </BarGraph>
				</section>
			</section>
        </b-card>
	</div>
</template>
<script>
import moment from 'moment'
import BarGraph from '../sections/dashboard/charts/templates/BarGraph.vue';
import Multiselect from 'vue-multiselect';
export default {
	props: {
	},
	components: { BarGraph, Multiselect },
	data() {
		let startDate  = moment().subtract(3,"days").format("YYYY-MM-DD");
        let endDate    = moment().subtract(-1,"days").format("YYYY-MM-DD");
		return {
			loading: false,
			loadingDetails: false,
			loadingPercent:0,
			forceStop:false,
			quoteRequests:[],
			airportSelected:null,
			listAirports:[],
			maxDate:endDate,
			filters:{
				module:"resume",
				serviceStartDate:null,
				serviceEndDate:null,
				startDate:startDate,
				endDate:endDate,
				confQuote:false,
				withTotal:false,
				pointOfSalesSelected:null
			},
			keySearch:null,
			loaded:{
				airports:[],
				cutoffPerAirport:{},
				serviceDatePerAirport:{},
				hotelsPerAirport:{}
			},
			loadedIatas: [] // Track which IATAs have been loaded
		};
	},
	computed: {
		totalQuotes() {
			return this.quoteRequests.length;
		},
		filtersComputed(){
			let filters = this.filters;
			filters.pointOfSalesIds = this.pointOfSalesIds;
			return filters;
		},
		
		pointOfSalesIds(){
			let type = typeof this.filters.pointOfSalesSelected;
			let val  = []
			if(this.$root.isEmpty(this.filters.pointOfSalesSelected)) return val;
			switch(type){
				case "object":
					val =  [this.filters.pointOfSalesSelected.id]
				break;
				case "array":
					val=  this.filters.pointOfSalesSelected.map(a=>a.value);
				break;
			}
			return val;
		}
	},
	methods: {
		getRange(startDate, endDate, type) {
			if(startDate == endDate) return[moment(startDate)]
			let fromDate = moment(startDate)
			let toDate = moment(endDate)
			let diff = toDate.diff(fromDate, type)
			let range = []
			for (let i = 0; i <= diff; i++) {
				range.push(moment(startDate).add(i, type))
			}
			return range
		},
		async fetch(filters){
			this.loading = true;

			// Fetch top airports
			try{
				const airportsRes = await this.$root.api.post(`/quotes-tool-analisis/top-airports`,filters);

				// Store airport data
				if(!this.$root.isEmpty(airportsRes.data.aptos_with_drilldown)){
					this.loaded.airports = airportsRes.data.aptos_with_drilldown;
				}

				// Populate airports list for selector
				if(!this.$root.isEmpty(airportsRes.data.airports)){
					this.listAirports = [...["Seleccione una opcion"], ...airportsRes.data.airports];
				}

				console.log("Top airports fetched:", airportsRes.data.airports);
			}catch(err){
				this.$root.handleRequestError(err)
				//console.error("Error fetching top airports:", err);
			}

			this.loading = false;

			// Apply main chart
			if(!this.$root.isEmpty(this.loaded.airports)){
				setTimeout(() => {
					this.applyDataToMainChart();
				}, 0);
			}
		},
		async getDetailsByIata(filters){
			this.loadingDetails = true;
			let selectedIata = filters.selectedIata;

			// Add required data to filters
			filters = {
				...filters,
				startDate: this.filters.startDate,
				endDate: this.filters.endDate,
				selectedIata: selectedIata,
				searchControl:{
					keySearch: this.keySearch
				}
			}

			let res = null;
			try{
				console.log("Fetching details for IATA:", selectedIata)
				res = await this.$root.api.post(`/quotes-tool-analisis/quotes`, filters)
			}catch(err){
				this.$root.handleRequestError(err);
				this.$root.showAlert("Ocurrió un error al generar el reporte",{variant:"danger"});
			}

			// Limpiar caché
			await this.cleanupCache();

			this.loadingDetails = false;

			if(!this.$root.isEmpty(res?.data)){
				// Merge data for each airport (res.data contains data keyed by IATA)
				this.loaded.cutoffPerAirport = {...this.loaded.cutoffPerAirport, ...(res.data.cutoffPerAirport??{})};
				this.loaded.serviceDatePerAirport = {...this.loaded.serviceDatePerAirport, ...(res.data.serviceDatePerAirport??{})}
				this.loaded.hotelsPerAirport = {...this.loaded.hotelsPerAirport, ...(res.data.hotelsPerAirport??{})}

				// Mark this IATA as loaded
				if(selectedIata && !this.loadedIatas.includes(selectedIata)){
					this.loadedIatas.push(selectedIata);
				}

				// Apply charts for selected airport
				setTimeout(() => {
					this.applyDataTochartsPerAirport();
				}, 0);
			}
		},
		async cleanupCache(){
			if(!this.keySearch) return;
			try{
				await this.$root.api.delete(`/quotes-tool-analisis/cache/${this.keySearch}`, {
					params: {
						dateRange: {
							start: this.filters.startDate,
							end: this.filters.endDate
						}
					}
				});
				console.log("Cache limpiado para keySearch:", this.keySearch);
			}catch(err){
				console.error("Error al limpiar cache:", err);
			}
		},

		searchAction(){
			this.keySearch= this.generateUUID();
			let filters = {...this.filtersComputed}
			this.fetch(filters)
		},
		generateUUID() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				const r = Math.random() * 16 | 0;
				const v = c === 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		},
		applyDataToMainChart(){
			console.log("--->",this.loaded.airports)
			let chartOptionsIatas = {
					chart: {
						type: 'column'
					},
					yAxis: {
						min: 0,
						title: {
							text: 'Cotizaciones'
						}
					},
					series:[{
						name:"Aeropuertos [Iatas]",
						data: this.loaded.airports.series
					}],
					drilldown:{series:this.loaded.airports.drilldown}
			}
			this.$refs["aptos-chart"].setChartOptions(chartOptionsIatas);
		},
		applyDataTochartsPerAirport(){

			
			let seriesCutoff = [{
				name:"Days in advance [Cutoff]",
				data: this.loaded.cutoffPerAirport[this.airportSelected]??[],
			}]
			let seriesServiceDates = [{
				name:"Service Date",
				data: this.loaded.serviceDatePerAirport[this.airportSelected]??[],
			}]
			let seriesHotels = [{
				name:"Hotels",
				data: this.loaded.hotelsPerAirport[this.airportSelected]??[],
			}]
			let chartOptions = {
				chart: {
					type: 'column'
				},
				yAxis: {
					min: 0,
					title: {
						text: 'Cotizaciones'
					}
				},
				colors: ['#FF5733', '#3399FF']
			}
			
			try{
				this.$refs["cutoff-chart"].setChartOptions({...chartOptions,...{series:seriesCutoff},...{colors:["#2CF55A"]}});
			}catch(err){
				console.log(err)
			}
			try{
				this.$refs["service-dates-chart"].setChartOptions({...chartOptions,...{series:seriesServiceDates},...{colors:["#4CJ55A"]}});
			}catch(err){
				console.log(err)
			}
			try{
				this.$refs["hotels-chart"].setChartOptions({...chartOptions,...{series:seriesHotels},...{colors:["#FFA500"]}});
			}catch(err){
				console.log(err)
			}

		}



	},
	mounted() {
        this.$emit('mounted')
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['pointOfSalesOpts']})
	},
	watch: {
		airportSelected(val){
			if(!this.$root.isEmpty(val) && val !== "Seleccione una opcion"){
				console.log("Airport selected:", val)

				// Check if data for this IATA is already loaded
				if(this.loadedIatas.includes(val)){
					console.log("Data already loaded for:", val)
					// Just apply the charts with existing data
					setTimeout(() => {
						this.applyDataTochartsPerAirport();
					}, 0);
				} else {
					// Fetch data for this IATA
					let filters = {...this.filtersComputed, selectedIata: val}
					this.getDetailsByIata(filters)
				}
			}
		}
	}
};
</script>

<style scoped>

#zones-map {
	width: 100%;
	height: 700px;
}
#zoned-rate-editor .card-body{
    color:black !important
}
</style>

